import { format as fnsFormat, isValid } from 'date-fns';

export type DateType = Date | null | undefined;

export type DateTypeRange = Readonly<[start: DateType, end: DateType]>;

export function transformToDateOrNull(date: unknown) {
  if (date) {
    try {
      const result = new Date(date as Date);
      if (isValid(result)) return result;
      // eslint-disable-next-line no-empty
    } catch {}
  }
  return null;
}

export function safeFnsFormat(
  date: unknown,
  format: string,
  options?: {
    locale?: Locale;
    weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    firstWeekContainsDate?: number;
    useAdditionalWeekYearTokens?: boolean;
    useAdditionalDayOfYearTokens?: boolean;
  }
) {
  // eslint-disable-next-line no-underscore-dangle
  const date_ = transformToDateOrNull(date);

  if (date_) {
    try {
      return fnsFormat(date_, format, options);
      // eslint-disable-next-line no-empty
    } catch {}
  }
  return '';
}
